// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3H1dr","amount":"Amount_amount__1AcKc","tip":"Amount_tip__3Ghk6","tipHeader":"Amount_tipHeader__2ld8c","tipsWrap":"Amount_tipsWrap__37f0M"};